var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sg-dialog',{attrs:{"full-screen":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('sg-button',{style:({
        position: 'absolute',
        zIndex: '200',
        top: '10px',
        left: '10px',
      }),attrs:{"color":"white"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":require('../../../../images/chevron-left.svg'),"alt":"Back icon"}})]),_vm._v(" "),_c('area-map',{attrs:{"property":_vm.property,"show-zoom-controls":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }